import get from 'lodash/get';

/**
 * Returns the Customer ID from RBI's Order Search.
 * RBI has three different keys for the Customer ID:
 * - rbiCouponsInfo.loyaltyInfo.customer.customerId
 * - rbiCouponsInfo.loyaltyInfo.customer.thLegacyCognitoId
 * - rbiCustomerId
 *
 * This should be refactored/removed if backend is
 * able to consolidate the Customer ID into a singular
 * property.
 *
 * @param {Object} ordersSearch
 * @returns {String} customerId
 */
const getCustomerId = (ordersSearch) => {
  const customerId = get(ordersSearch, 'rbiCouponsInfo.loyaltyInfo.customer.customerId', '');
  const legacyCustomerId = get(ordersSearch, 'rbiCouponsInfo.loyaltyInfo.customer.thLegacyCognitoId', '');
  const rbiCustomerId = get(ordersSearch, 'rbiCustomerId', '');

  return legacyCustomerId || customerId || rbiCustomerId;
};

const getKeyToFunction = {
  customerId: getCustomerId,
};

const getValue = (ordersSearch, key) => {
  const mappedFunction = getKeyToFunction[key];

  return mappedFunction ? mappedFunction(ordersSearch) : get(ordersSearch, key, '');
};

export default {
  getValue,
};
